"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
exports.defaultConfig = {
    loadOnStart: {
        cart: true,
        checkout: true,
    },
};
//# sourceMappingURL=config.js.map